<template>
  <div class="not-found fixed-background">
    <div class="relative">
      <div class="content">
        <h1>Page not found</h1>

        <div class="links">
          <router-link to="/">Home</router-link>
          <router-link to="/my-work">My Work</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>